import { mapMessage } from '../mappers';
import { fetchWebHistoryMessages, TWebHistoryMessagesResponse } from '../repositories/chats/v3/web/history/messages';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

// переменная используется для отслеживания события первого сообщения
export const HISTORY_MESSAGES_REQUEST_LIMIT = 100;

interface IWebHistoryMessagesRequestParameters {
  chatId: string;
  /** Дата, после которой нужно получить сообщения  ISO-8601, пример: 2022-08-01T01:34:03.123456+00:00. **/
  createdAt?: string;
  rowVersionsHash?: string;
}

type TFetchWebHistoryMessagesParams = {
  parameters: IWebHistoryMessagesRequestParameters;
  cookies?: string;
};

const DEFAULT_ERROR_MESSAGE = 'Ошибка при получении сообщений чата';

export async function fetchHistoryMessages(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchWebHistoryMessagesParams,
) {
  try {
    const { response, statusCode }: TWebHistoryMessagesResponse = await fetchWebHistoryMessages({
      httpApi,
      parameters: {
        ...parameters,
        limit: HISTORY_MESSAGES_REQUEST_LIMIT,
      },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Messages,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return {
      response: {
        ...response,
        messages: response.messages.map(mapMessage),
      },
      error: null,
    };
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Messages,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v3/web/history/messages/',
      parameters: JSON.stringify(parameters),
    });

    return { response: null, error };
  }
}
